import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "DataWorkerClient" */ './lazyIndex'),
    { name: 'DataWorkerClient' }
);

export const lazyExecuteRequest: LazyAction<typeof lazyIndex.executeRequest, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.executeRequest);
export const lazyUnsubscribe: LazyAction<typeof lazyIndex.unsubscribe, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.unsubscribe);
export const lazySetDisableAllRequests: LazyAction<
    typeof lazyIndex.setDisableAllRequests,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setDisableAllRequests);
export const lazyFlushSyncLogs: LazyAction<typeof lazyIndex.flushSyncLogs, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.flushSyncLogs);
export const lazyOnManualSyncMail: LazyAction<
    typeof lazyIndex.onManualSyncMail,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onManualSyncMail);
export const lazySaveOfflineSessionData: LazyAction<
    typeof lazyIndex.saveOfflineSessionData,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.saveOfflineSessionData);
export const lazyGetOfflineTimeZones: LazyAction<
    typeof lazyIndex.getOfflineTimeZones,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getOfflineTimeZones);
export const lazyGetOfflineTimeZoneOffsets: LazyAction<
    typeof lazyIndex.getOfflineTimeZoneOffsets,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getOfflineTimeZoneOffsets);
export const lazyScheduleHierarchySync: LazyAction<
    typeof lazyIndex.scheduleHierarchySync,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.scheduleHierarchySync);
export const lazyOnManualSyncPGAL: LazyAction<
    typeof lazyIndex.onManualSyncPGAL,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onManualSyncPGAL);
export const lazyOnManualSyncCalendar: LazyAction<
    typeof lazyIndex.onManualSyncCalendar,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onManualSyncCalendar);
export const lazySetAccountTimeZone: LazyAction<
    typeof lazyIndex.setAccountTimeZone,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setAccountTimeZone);
export const lazyNotifyWorkerLocaleChanged: LazyAction<
    typeof lazyIndex.notifyWorkerLocaleChanged,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.notifyWorkerLocaleChanged);
export const lazyLoadOfflineSettings: LazyAction<
    typeof lazyIndex.loadOfflineSettings,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadOfflineSettings);
export const lazySaveOfflineSettings: LazyAction<
    typeof lazyIndex.saveOfflineSettings,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.saveOfflineSettings);
export const lazyInvalidateOfflineConversationNodes: LazyAction<
    typeof lazyIndex.invalidateOfflineConversationNodes,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.invalidateOfflineConversationNodes);
export const lazyLogPeopleDataToSyncLogs: LazyAction<
    typeof lazyIndex.logPeopleDataToSyncLogs,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logPeopleDataToSyncLogs);
export const lazyLoadPeopleAppData: LazyAction<
    typeof lazyIndex.loadPeopleAppData,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadPeopleAppData);
export const lazyGetBroadcast: LazyAction<typeof lazyIndex.getBroadcast, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getBroadcast);
